import { render, staticRenderFns } from "./channelType.vue?vue&type=template&id=006bc995&scoped=true&"
import script from "./channelType.vue?vue&type=script&lang=js&"
export * from "./channelType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006bc995",
  null
  
)

export default component.exports